module.exports = "<div class=\"page-spinner\">\n\t<spinner class=\"inline\"></spinner>\n\t<div class=\"explanation\">\n\t\t<slot></slot>\n\t</div>\n</div>\n"